form.noauth-login {
  border: 1px solid #ccc;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  width: 300px;
  margin: 0 auto;

  & .show {
    display: block;
  }

  & .hide {
    display: none;
  }

  & .noauth-step {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  & input,
  & button {
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 0.25rem;

    &.account-recovery-btn {
      background: transparent;
      border: none;
    }
  }

  & .message {
    padding: 0.5rem;
    border-radius: 0.25rem;

    &.error {
      border: 1px solid red;
      background-color: #feedee;
      color: #dd0000;
    }

    &.success {
      border: 1px solid green;
    }
  }
}
